import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
    EmailIconSvg,
    GoogleSvg,
    PasswordHideIcon,
    PasswordLockSvg,
    PasswordShowIcon,
} from "../assets/svg/SvgComponent";
import axios from "axios";
import { API_URL, getHeaders, GOOGLE_API_KEY } from "../helper/commonApi"; // Make sure this is at the top
import { useBranding } from "../context/BrandingContext";
import toast from "react-hot-toast";


const LoginPageComponent = () => {
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPass, setShowPass] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    // const googleButtonRef = useRef(null);

    const { colors, portalID } = useBranding();

    const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

    // useEffect(() => {
    //     let userId = localStorage.getItem('_register_GRE_LOGIN_userId');
    //     if (userId) {
    //         navigate('/dashboard')
    //     }

    //     const script = document.createElement("script");
    //     script.src = "https://accounts.google.com/gsi/client";
    //     script.async = true;
    //     script.defer = true;
    //     script.onload = () => {
    //         if (window.google) {
    //             window.google.accounts.id.initialize({
    //                 client_id: GOOGLE_API_KEY,
    //                 callback: handleCredentialResponse,
    //                 ux_mode: "popup",
    //             });

    //             googleButtonRef.current = createFakeGoogleWrapper();
    //         }
    //     };
    //     document.body.appendChild(script);

    // }, [])

    useEffect(() => {
        const userId = localStorage.getItem("_register_GRE_LOGIN_userId");
        if (userId) {
            navigate("/dashboard");
            return;
        }

        // Load Google script
        const script = document.createElement("script");
        script.src = "https://accounts.google.com/gsi/client";
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);

        script.onload = () => {
            if (window.google) {
                // Pre-initialize client so it's ready for handleGoogleLogin
                window.googleClient = window.google.accounts.oauth2.initTokenClient({
                    client_id: GOOGLE_API_KEY,
                    scope: "email profile openid",
                    callback: handleGoogleResponse,
                });
            }
        };

        return () => {
            document.body.removeChild(script); // cleanup script on unmount
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // const parseJwt = (token) => {
    //     const base64Url = token.split(".")[1];
    //     const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    //     const jsonPayload = decodeURIComponent(
    //         atob(base64)
    //             .split("")
    //             .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
    //             .join("")
    //     );
    //     return JSON.parse(jsonPayload);
    // };

    // const handleCredentialResponse = (response) => {
    //     const userData = parseJwt(response.credential);
    //     handleLogin(userData, true)
    // };

    // const createFakeGoogleWrapper = () => {
    //     const wrapper = document.createElement("div");
    //     wrapper.style.display = "none";
    //     wrapper.classList.add("custom-google-button");
    //     document.body.appendChild(wrapper);

    //     window?.google?.accounts?.id?.renderButton(wrapper, {
    //         type: "icon",
    //         width: "200",
    //     });

    //     const button = wrapper.querySelector("div[role=button]");
    //     return () => {
    //         if (button) button.click();
    //     };
    // };

    const handleGoogleResponse = async (response) => {
        try {
            setLoading(true);

            const res = await axios.post(
                `${API_URL}/google-login`,
                {
                    access_token: response.access_token,
                    portal_id: portalID,
                },
                { headers: getHeaders() }
            );


            if (res?.data?.status) {
                const { user_id, full_name, jwt_token, email, token_expires_in } = res.data.data;

                localStorage.setItem("_register_GRE_LOGIN_userId", user_id);
                localStorage.setItem("_register_GRE_LOGIN_full_name", full_name);
                localStorage.setItem("_register_GRE_userEmail", email)
                localStorage.setItem("_register_GRE_LOGIN_JWT_TOKEN", jwt_token);

                const tokenExpires = token_expires_in || 18000;
                const expires = new Date(Date.now() + tokenExpires * 1000).toUTCString();
                document.cookie = `_GRE_JWT_TOKEN=${jwt_token}; expires=${expires}; path=/; Secure; SameSite=Strict`;

                navigate("/dashboard");
                toast.success(res?.data?.message)

            } else {
                setErrors({ form: res?.data?.message || "Google login failed" });
            }
        } catch (err) {
            console.error("Google login error:", err);
            setErrors({ form: "Google login failed. Try again." });
        } finally {
            setLoading(false);
        }
    };

    const handleGoogleLogin = () => {
        // if (googleButtonRef.current) {
        //     googleButtonRef.current();
        // }

        if (window.googleClient) {
            window.googleClient.requestAccessToken(); // Trigger Google login popup
        } else {
            setErrors({ form: "Google client not initialized yet." });
        }
    };


    const handleLogin = async (userData, passWithoutValidation = false) => {

        const validationErrors = {};
        if (!passWithoutValidation) {
            if (!email.trim()) {
                validationErrors.email = "Email is required.";
            } else if (!validateEmail(email)) {
                validationErrors.email = "Enter a valid email.";
            }

            if (!password) {
                validationErrors.password = "Password is required.";
            }

            if (Object.keys(validationErrors).length > 0) {
                setErrors(validationErrors);
                return;
            }
        }


        setErrors({});
        setLoading(true);

        let emailLogin = email;

        let payload = {
            // site: "omc",
            portal_id: portalID,
            email: email,
            password: password
        }

        if (passWithoutValidation) {
            emailLogin = userData?.email;
            payload.email = userData?.email;
            payload.google = true;
            payload.password = userData?.email;
        }

        try {
            const res = await axios.post(`${API_URL}/login`, payload, {
                headers: getHeaders()
            });

            if (!res.data?.status) {
                const userId = res?.data?.data?.user_id;
                const otpRequired = res?.data?.data?.require_otp;

                if (otpRequired) {
                    localStorage.setItem('_register_GRE_userId', userId)
                    localStorage.setItem('_register_GRE_userEmail', emailLogin)
                    localStorage.setItem('_register_GRE_isLogin', true)

                    await handleResendOtp(userId, emailLogin);
                    return;
                }
            }

            if (res?.status === 200 || res?.status === 201) {
                const userId = res?.data?.data?.user_id;
                const otpRequired = res?.data?.data?.require_otp;
                const fullName = res?.data?.data?.full_name;
                const token = res?.data?.data?.jwt_token;

                // const tokenExpires = res?.data?.data?.token_expires_in;
                // const expires = new Date(Date.now() + (tokenExpires || 18000) * 1000).toUTCString();

                const tokenExpires = res.data.data.token_expires_in || 18000;
                const expires = new Date(Date.now() + tokenExpires * 1000).toUTCString();

                if (!res?.data?.status) {
                    setErrors({ form: res?.data?.message || "Something went wrong" });
                    return;
                }

                if (otpRequired) {
                    localStorage.setItem('_register_GRE_userId', userId)
                    localStorage.setItem('_register_GRE_userEmail', emailLogin)
                    localStorage.setItem('_register_GRE_isLogin', true)

                    await handleResendOtp(userId, emailLogin);
                } else {
                    localStorage.setItem('_register_GRE_LOGIN_userId', userId)
                    localStorage.setItem('_register_GRE_LOGIN_full_name', fullName)

                    // localStorage.setItem('_register_GRE_LOGIN_JWT_TOKEN', token)
                    document.cookie = `_GRE_JWT_TOKEN=${token}; expires=${expires}; path=/; Secure; SameSite=Strict`;

                    navigate("/dashboard");
                }
            } else {
                setErrors({ form: res?.data?.message || "Something went wrong" });
                setLoading(false);
            }
        } catch (error) {
            if (error.response?.data?.message) {
                setErrors({ form: error.response.data.message });
                setLoading(false);
            } else {
                setErrors({ form: "Something went wrong." });
                setLoading(false);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleResendOtp = async (userId, emailLogin) => {
        try {
            const res = await axios.post(`${API_URL}/resend-otp`, {
                email: emailLogin,
                portal_id: portalID,
                user_id: userId,
            }, {
                headers: getHeaders()
            });
            if (res.status === 200 && res?.data?.status) {
                navigate("/verify-mail");
            } else {
                setErrors(res?.data?.message || "Invalid OTP.");
            }
        } catch (err) {
            console.log("Failed to resend OTP. Please try again.");
        }
    };


    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleLogin();
        }
    };

    return (
        <div style={{ margin: "20px" }} onKeyDown={handleKeyDown}>
            <div className="form-container" style={{ position: "relative" }}>
                <div className="create-account" >
                    <h1>
                        Welcome to the OMC GRE Test App
                        <sup style={{ color: "red" }}>*</sup>
                    </h1>
                    <p>Login to access your GRE Ace Dashboard</p>

                    <div className="form">
                        <div className="input-wrapper">
                            <div className={`input-group ${errors.email ? "error" : ""}`}>
                                <EmailIconSvg />
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    placeholder="Enter your mail here"
                                    value={email}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        setEmail(val);
                                        if (!val.trim()) {
                                            setErrors((prev) => ({ ...prev, email: "Email is required." }));
                                        } else if (!validateEmail(val)) {
                                            setErrors((prev) => ({ ...prev, email: "Enter a valid email." }));
                                        } else {
                                            setErrors((prev) => ({ ...prev, email: undefined }));
                                        }
                                    }}

                                />
                            </div>
                            {errors.email && <span className="error-text">{errors.email}</span>}
                        </div>

                        <div className="input-wrapper">
                            <div className={`input-group ${errors.password ? "error" : ""}`}>
                                <PasswordLockSvg />
                                <input
                                    id="password"
                                    name="password"
                                    type={showPass ? "text" : "password"}
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        setPassword(val);
                                        if (val) {
                                            setErrors((prev) => ({ ...prev, password: undefined }));
                                        }
                                    }}
                                />
                                <div
                                    className="input-type-password-toggle"
                                    onClick={() => setShowPass(!showPass)}
                                >
                                    {showPass ? <PasswordShowIcon /> : <PasswordHideIcon />}
                                </div>
                            </div>
                            {errors.password && (
                                <span className="error-text">{errors.password}</span>
                            )}
                        </div>

                        <div style={{ cursor: "pointer" }} className="forgot-pass">
                            <div className="text" onClick={() => navigate("/forgot-password")}>Forgot Your Password?</div>
                        </div>

                        {errors.form && <div className="error-text" style={{ textAlign: "center" }}>{errors.form}</div>}

                        <button
                            className="register-btn btn black"
                            onClick={handleLogin}
                            disabled={loading}
                            style={{ backgroundColor: colors?.buttonBg }}
                        >
                            {loading ? <span className="loader-small" /> : "Login"}
                        </button>

                        <div className="register-text">
                            {/* <strong>Login</strong> <span>with Others</span> */}
                            <strong> New user? </strong>
                            <span
                                onClick={() => navigate("/register")}>
                                Register now
                            </span>
                        </div>
                    </div>

                    <div className="google-login" onClick={handleGoogleLogin}>
                        <GoogleSvg />
                        Login with <span>google</span>
                    </div>
                </div>

                <div style={{ color: "red", position: "absolute", bottom: "12px", right: "20px" }}>* beta release</div>
            </div>
        </div>
    );
};

export default LoginPageComponent;
